import { gql } from "@outschool/ui-apollo";

export const blockLearnerMutation = gql`
  mutation BlockLearner(
    $educatorUid: ID!
    $learnerUid: ID!
    $reason: String!
    $note: String
  ) {
    blockLearner(
      educatorUid: $educatorUid
      learnerUid: $learnerUid
      reason: $reason
      note: $note
    )
  }
`;

export const unblockLearnerMutation = gql`
  mutation UnblockLearner($educatorUid: ID!, $learnerUid: ID!) {
    unblockLearner(educatorUid: $educatorUid, learnerUid: $learnerUid)
  }
`;
